import { Tooltip } from "flowbite-react";
import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";

interface LabelProps {
  htmlFor: string;
  label: string;
  required?: boolean;
}

export const Label: React.FC<LabelProps & { tooltip?: string }> = ({
  htmlFor,
  label,
  required,
  tooltip,
}) => {
  return (
    <div className="mb-2 block">
      <label
        htmlFor={htmlFor}
        className="flex gap-1 mb-2 text-sm font-semibold text-gray-900 dark:text-white"
      >
        {label} {required ? <span className="text-red-500">*</span> : ""}
        {tooltip && (
          <Tooltip content={tooltip} arrow={false} style="dark">
            <span className="mb-1 text-[#00000040]">
              <AiOutlineInfoCircle className="inline-block w-4 h-4 cursor-pointer" />
            </span>
          </Tooltip>
        )}
      </label>
    </div>
  );
};
